/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Crop_LeftInputs */



/**
* | output |
* | --- |
* | "Left (%)" |
*
* @param {Ocr_Crop_LeftInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_crop_left = /** @type {((inputs?: Ocr_Crop_LeftInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Crop_LeftInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gauche (%)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Links (%)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sinistra (%)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Левый (%)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Izquierda (%)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("左边 （％）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("左 （％）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बाएं (%)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Esquerda (%)")
	return /** @type {LocalizedString} */ ("Left (%)")
});